import React, { useCallback, useContext } from 'react';
import { StyleSheet } from 'react-native';
import GenericHeader from '../components/headers/GenericHeader';
import Cart from '../components/cart/Cart';
import { AnalyticsService } from "../constants/Analytics";
import { useFocusEffect } from '@react-navigation/native';
import { AuthContext } from '../contexts/auth/Store';

const analytics = new AnalyticsService();

export default function CartScreen() {
  const auth = useContext(AuthContext);

  useFocusEffect(
    useCallback(() => {
      analytics.logEvent('Viewed Cart', auth.getUserData.buyerData)
      analytics.googleHelpers.setCurrentScreen('ViewedCart', 'ViewedCart')
      return () => { }
    }, [])
  )

  return (
    <>
      <GenericHeader
        title={`My Cart`}
      />
      <Cart />
    </>
  );
}

const styles = StyleSheet.create({
});
